var map = {
	"./": 71,
	"./App": 56,
	"./App.js": 56,
	"./App.test": 147,
	"./App.test.js": 147,
	"./Nav": 93,
	"./Nav.jsx": 93,
	"./NavBar": 97,
	"./NavBar.jsx": 97,
	"./NavPhone": 98,
	"./NavPhone.jsx": 98,
	"./NavScreen": 99,
	"./NavScreen.jsx": 99,
	"./data/cardData": 96,
	"./data/cardData.js": 96,
	"./data/flowChartData": 20,
	"./data/flowChartData.js": 20,
	"./figures/22_2021_Clinical_Guidelines_7.29.2021_fp.pdf": 195,
	"./figures/23_Clinical_Guidelines_National.pdf": 196,
	"./figures/English V Grayken Colors 121_118_Home_Buprenorphine_Initiation_NIDA_ 09-2022_FINAL.jpg": 544,
	"./figures/English V Grayken Colors 121_118_Home_Buprenorphine_Initiation_NIDA_ 09-2022_FINAL.pdf": 197,
	"./figures/Initiation of Monthly Injectionable Buprenorphine  SLIDE 08-22_FINAL.jpg": 545,
	"./figures/Initiation of Monthly Injectionable Buprenorphine  SLIDE 08-22_FINAL.pdf": 198,
	"./figures/Naltrexone Initiation for Alcohol Use Disorder SLIDE 09-22_ FINAL.jpg": 546,
	"./figures/Naltrexone Initiation for Alcohol Use Disorder SLIDE 09-22_ FINAL.pdf": 199,
	"./figures/Pain Management While on Buprenorphine for Opioid Use Disorder 08-22_FINAL.jpg": 547,
	"./figures/Pain Management While on Buprenorphine for Opioid Use Disorder 08-22_FINAL.pdf": 200,
	"./figures/Pain Management While on Naltrexone for Opioid Use Disorder 1-25-2023.jpg": 548,
	"./figures/Pain Management While on Naltrexone for Opioid Use Disorder 1-25-2023.pdf": 201,
	"./figures/QSG_2022.jpg": 549,
	"./figures/QSG_2022.pdf": 202,
	"./figures/Spanish V Grayken Colors 121_118_Home_Buprenorphine_Initiation_NIDA_ 09-2022_FINAL.jpg": 550,
	"./figures/Spanish V Grayken Colors 121_118_Home_Buprenorphine_Initiation_NIDA_ 09-2022_FINAL.pdf": 203,
	"./figures/naltrexone-initiation-for-opioid-use-disorder 09-22_FINAL.jpg": 551,
	"./figures/naltrexone-initiation-for-opioid-use-disorder 09-22_FINAL.pdf": 204,
	"./figures/npg-jam-supplement.pdf": 205,
	"./index": 71,
	"./index.js": 71,
	"./parse": 25,
	"./parse.js": 25,
	"./questionFlows/AlgorithmSection": 100,
	"./questionFlows/AlgorithmSection.jsx": 100,
	"./questionFlows/ClinicalToolFlow": 101,
	"./questionFlows/ClinicalToolFlow.jsx": 101,
	"./questionFlows/ManagementFlow": 102,
	"./questionFlows/ManagementFlow.jsx": 102,
	"./serviceWorker": 103,
	"./serviceWorker.js": 103,
	"./setupTests": 207,
	"./setupTests.js": 207,
	"./styles/index.css": 142,
	"./styles/nav.scss": 19,
	"./subviews/Card": 40,
	"./subviews/Card.jsx": 40,
	"./subviews/Question": 48,
	"./subviews/Question.jsx": 48,
	"./tabViews/MainTabView": 94,
	"./tabViews/MainTabView.jsx": 94,
	"./tabViews/PDFView": 239,
	"./tabViews/PDFView.jsx": 239,
	"./tabViews/QuestionSection": 57,
	"./tabViews/QuestionSection.jsx": 57,
	"./tabViews/QuestionnaireStart": 95,
	"./tabViews/QuestionnaireStart.jsx": 95,
	"./thumb/Algorithm.png": 128,
	"./thumb/Books.png": 193,
	"./thumb/Clipboard.png": 129,
	"./thumb/Document.png": 108,
	"./thumb/Globe.png": 192,
	"./thumb/Organizations.png": 194,
	"./thumb/Plus.png": 191,
	"./thumb/brain.png": 143,
	"./thumb/down_arrow.png": 206,
	"./thumb/logo.png": 700,
	"./thumb/logos1.png": 242,
	"./thumb/logos2.png": 243,
	"./thumb/logos3.png": 244
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 271;